import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';

import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';
import DateFormat from '../../lib/date/DateFormat';
import { AddressInfo } from '.';

let ContactInfo = ({ translate, currentLanguage, user}) => {
  const address = AddressInfo(user);
  return (
    <div className="card card-section" id="info">
      <div className="card-block">
        <div className="card-title">
          <h3>{translate('contact-information')}</h3>
        </div>
        <div className="form-line">
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <div className="form-group">
                <label>{translate('first-name')}</label>
                <div className="form-control">{user.fname}</div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="form-group">
                <label>{translate('last-name')}</label>
                <div className="form-control">{user.lname}</div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="form-group">
                <label>{translate('birth-date')}</label>
                <div className="form-control"><DateFormat date={user.dob} /></div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="form-group">
                <label>{translate('phone')}</label>
                <div className="form-control">{PhoneNumberFormat(user.tel)}</div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 push-lg-4">
              <div className="form-group">
                <label>{translate('other-phone')}</label>
                <div className="form-control">{PhoneNumberFormat(user.tel2)}</div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 pull-lg-4">
              <div className="form-group">
                <label>email</label>
                <div className="form-control">{user.email}</div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4"></div>
            <div className="col-12">
              <div className="form-group">
                <label>{translate('address')}</label>
                <div className="form-control">{address}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    user: state.User.user,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {

  }
}

ContactInfo = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(ContactInfo);
export default ContactInfo;



// WEBPACK FOOTER //
// ./src/components/InfoPerson/ContactInfo.js